// src/utils/formatters.ts

export const formatPrice = (amount: any) => {
  const val = parseFloat(amount);
  return isNaN(val) ? '0,00' : val.toFixed(2).replace('.', ',');
};

export const formatDateEU = (dateString: string) => {
    if (!dateString) return '-';
    if (dateString.length === 4) return dateString; 
    const parts = dateString.split('-');
    if (parts.length === 3 && parts[0].length === 4) {
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return dateString;
};

export const formatAgendaDay = (dateString: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const days = ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'];
    return `${days[date.getDay()]} ${date.getDate()}-${date.getMonth()+1}`;
};

export const parseDutchPrice = (priceString: any) => {
    if (!priceString) return 0;
    const cleanString = priceString.toString().replace(/€/g, '').replace(/\s/g, '').replace(',', '.');
    return parseFloat(cleanString) || 0;
};

export const getCategoryColor = (category: string) => {
    switch(category) {
        case 'Snaar': return 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300';
        case 'Basisgrip': return 'bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-300';
        case 'Overgrip': return 'bg-pink-100 text-pink-700 dark:bg-pink-900/30 dark:text-pink-300';
        case 'Demper': return 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-300';
        default: return 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-300';
    }
};